import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { LeadPopup } from "@/components/LeadPopup";
import { FloatingCtas } from "@/components/FloatingCtas";
import { captureUtm } from "@/utm";
import Home from "@/pages/Home";
import ConfigPage from "@/pages/ConfigPage";
import FloorPlans from "@/pages/FloorPlans";
import Amenities from "@/pages/Amenities";
import Location from "@/pages/Location";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => {
                const el = document.getElementById(hash.slice(1));
                if (el) el.scrollIntoView({ behavior: "smooth" });
            }, 60);
            return () => clearTimeout(t);
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

function App() {
    useEffect(() => {
        captureUtm();
    }, []);

    return (
        <BrowserRouter>
            <ScrollManager />
            <div className="flex min-h-screen flex-col pb-14 md:pb-0" data-testid="app-shell">
                <Header />
                <main className="flex-1">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/1-bhk" element={<ConfigPage config="1-bhk" />} />
                        <Route path="/2-bhk" element={<ConfigPage config="2-bhk" />} />
                        <Route path="/3-bhk" element={<ConfigPage config="3-bhk" />} />
                        <Route path="/floor-plans" element={<FloorPlans />} />
                        <Route path="/amenities" element={<Amenities />} />
                        <Route path="/location" element={<Location />} />
                        <Route path="/contact" element={<Contact />} />
                        {/* Legacy URL preservation — 301-equivalent redirects */}
                        <Route path="/location-map" element={<Navigate to="/location/" replace />} />
                        <Route path="/master-plan" element={<Navigate to="/#master-plan" replace />} />
                        <Route path="/pricing-schedule" element={<Navigate to="/#configurations" replace />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
                <FloatingCtas />
                <LeadPopup />
            </div>
        </BrowserRouter>
    );
}

export default App;
